// handlers.ts
import { useCallback } from "react";
import { CustomerFormData } from "../types";
import { sanitizeName, sanitizePhone, sanitizePincode } from "./validationUtils";

export const useFormHandlers = (formData: CustomerFormData, setFormData: React.Dispatch<React.SetStateAction<CustomerFormData>>, setIsDuplicatePhone: (val: boolean) => void) => {
  const handleChange = (field: keyof CustomerFormData, sanitizer?: (val: string) => string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    if (sanitizer) value = sanitizer(value);
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handlePhoneChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = sanitizePhone(e.target.value);
      setFormData((prev) => ({ ...prev, phoneNumber: value }));

      const digits = value.replace(/\D/g, "");
      const altDigits = formData.alternativePhone.replace(/\D/g, "");
      setIsDuplicatePhone(digits === altDigits && digits !== "");
    },
    [formData.alternativePhone, setFormData, setIsDuplicatePhone]
  );

  const handleAlternativePhoneChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = sanitizePhone(e.target.value);
      setFormData((prev) => ({ ...prev, alternativePhone: value }));

      const digits = value.replace(/\D/g, "");
      const mainDigits = formData.phoneNumber.replace(/\D/g, "");
      setIsDuplicatePhone(digits === mainDigits && digits !== "");
    },
    [formData.phoneNumber, setFormData, setIsDuplicatePhone]
  );

  return {
    handleNameChange: handleChange("name"),
    handlePhoneChange,
    handleAlternativePhoneChange,
    handleEmailChange: handleChange("email"),
    handleAddress1Change: handleChange("address1"),
    handleAddress2Change: handleChange("address2"),
    handlePincodeChange: handleChange("address3", sanitizePincode),
  };
};
